import { Action, createFeatureSelector, createReducer, createSelector, on } from '@ngrx/store';
import { selectCustomer, selectJob, selectMixDesign, selectTruck } from './batch-report-filter.actions';
import { SetFilterFormExpanded } from './batch-report-filter.actions';

export const featureKey = 'batch-report-filter';

export interface State {
  filterFormExpanded: boolean;
  selectedTruckId: number;
  selectedMixDesignId: number;
  selectedJobId: number;
  selectedCustomerId: number;
}

export interface AppState {
  [featureKey]: State;
}

export const initialState: State = {
  filterFormExpanded: false,
  selectedTruckId: null,
  selectedMixDesignId: null,
  selectedJobId: null,
  selectedCustomerId: null,
};

const batchReportFilterReducer = createReducer(
  initialState,
  on(selectTruck, (state, { truckId }): State => ({ ...state, selectedTruckId: truckId})),
  on(selectMixDesign, (state, { mixDesignId }): State => ({ ...state, selectedMixDesignId: mixDesignId})),
  on(selectJob, (state, { jobId }): State => ({ ...state, selectedJobId: jobId})),
  on(selectCustomer, (state, { customerId }): State => ({...state, selectedCustomerId: customerId})),
  on(SetFilterFormExpanded, (state, { expanded }): State => ({ ...state,
  filterFormExpanded: expanded })),
);

export function reducer(state: State | undefined , action: Action) {
  return batchReportFilterReducer(state, action);
}

export const selectBatchReportFilterState = createFeatureSelector<State>(featureKey);

export const selectSelectedTruckId = createSelector(selectBatchReportFilterState, (state: State) => state.selectedTruckId);

export const selectSelectedMixDesignId = createSelector(selectBatchReportFilterState, (state: State) => state.selectedMixDesignId);

export const selectSelectedJobId = createSelector(selectBatchReportFilterState, (state: State) => state.selectedJobId);

export const selectSelectedCustomerId = createSelector(selectBatchReportFilterState, (state: State) => state.selectedCustomerId);

export const selectFilterFormExpanded = createSelector(selectBatchReportFilterState, (state: State) => state.filterFormExpanded);
